/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Cross_Desc5Inputs */

const en_svc_browser_extensions_cross_desc5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One build that behaves consistently across Chrome, Firefox, and Edge, with browser-specific quirks handled.`)
};

const ar_svc_browser_extensions_cross_desc5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بناء واحد يتصرف باستمرار عبر Chrome و Firefox و Edge مع معالجة خصوصيات كل متصفح.`)
};

const bn_svc_browser_extensions_cross_desc5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome, Firefox ও Edge জুড়ে একই রকম আচরণ করে এমন একটি বিল্ড, ব্রাউজার-নির্দিষ্ট কুয়ার্কসহ।`)
};

const de_svc_browser_extensions_cross_desc5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Build, der sich in Chrome, Firefox und Edge konsistent verhält und browserspezifische Besonderheiten berücksichtigt.`)
};

const es_svc_browser_extensions_cross_desc5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un build que se comporta igual en Chrome, Firefox y Edge, con peculiaridades de cada navegador resueltas.`)
};

const fr_svc_browser_extensions_cross_desc5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une version qui se comporte de manière cohérente sur Chrome, Firefox et Edge, avec des bizarreries spécifiques au navigateur gérées.`)
};

const pt_svc_browser_extensions_cross_desc5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um build que se comporta igual no Chrome, Firefox e Edge, com peculiaridades de cada navegador resolvidas.`)
};

const zh_svc_browser_extensions_cross_desc5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一套构建在 Chrome、Firefox 和 Edge 上表现一致，各浏览器的坑都填过。`)
};

const tr_svc_browser_extensions_cross_desc5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome, Firefox ve Edge'de tutarlı bir şekilde çalışan ve tarayıcıya özgü tuhaflıkların ele alındığı tek bir yapı.`)
};

const ru_svc_browser_extensions_cross_desc5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Один билд, одинаково ведущий себя в Chrome, Firefox и Edge, с учтёнными особенностями браузеров.`)
};

const pl_svc_browser_extensions_cross_desc5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden build działający tak samo w Chrome, Firefox i Edge, z ogarniętymi dziwactwami przeglądarek.`)
};

/**
* | output |
* | --- |
* | "One build that behaves consistently across Chrome, Firefox, and Edge, with browser-specific quirks handled." |
*
* @param {Svc_Browser_Extensions_Cross_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_cross_desc5 = /** @type {((inputs?: Svc_Browser_Extensions_Cross_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Cross_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_cross_desc5(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_cross_desc5(inputs)
	if (locale === "de") return de_svc_browser_extensions_cross_desc5(inputs)
	if (locale === "es") return es_svc_browser_extensions_cross_desc5(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_cross_desc5(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_cross_desc5(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_cross_desc5(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_cross_desc5(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_cross_desc5(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_cross_desc5(inputs)
	return en_svc_browser_extensions_cross_desc5(inputs)
});
export { svc_browser_extensions_cross_desc5 as "svc_browser-extensions_CROSS_desc" }